module.exports = __webpack_public_path__ + "static/media/photo100.2c3f2e12.jpg";